import {
  PRICING_TABLE_STUDY_PACK,
  PRICING_TABLE_FREE,
} from '@chegg-wt/core/constants/pricingTable'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import { useRoutesContext } from '../RoutesContext'

export const useSignUpLink = (productId: string, studyPackUrl: string) => {
  const { toUpgrade, toSignup } = useRoutesContext()
  if (productId === PRICING_TABLE_STUDY_PACK) {
    return studyPackUrl
  }
  return productId === PRICING_TABLE_FREE
    ? routeToHref(toSignup())
    : routeToHref(toUpgrade())
}
